// removed by extract-text-webpack-plugin
module.exports = {"Overlay":"FormTechnicalProblem__Overlay___2SV3v","Modal":"FormTechnicalProblem__Modal___7uhnw","CloseButton":"FormTechnicalProblem__CloseButton___3mIW8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/FormTechnicalProblem/FormTechnicalProblem.scss
// module id = 1362
// module chunks = 0